export const ORDER_SPECIAL_REQUEST_TYPE = {
  laminatedCard: 'laminated_card',
  retest: 'retest',
  reschedule: 'reschedule',
};

/** Order special request, example: Laminated card order, ... */
export class OrderSpecialRequest {
  constructor(data) {
    this.id = data.id;
    this.userId = data.userId;
    this.orderItemId = data.orderItemId;
    this.registrationId = data.registrationId;
    this.type = data.type;
    this.newRegistrationId = data.newRegistrationId;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
}
